import React, { useRef, useEffect } from 'react';
import * as constantsViewer from '../../constants';
import { useSpring, a } from 'react-spring-beta/three';
import { Pane } from '../pieces/Pane';
import { CrossPiece } from '../pieces/CrossPiece';

export function Top({
  top,
  cabinetId,
  configuratorMode,
  cabinetWidth,
  cabinetDepth,
  cabinetHeight,
  unselected = false,
}) {
  const group = useRef();

  const [spring, set] = useSpring(() => ({
    position: getPosition(cabinetHeight),
    immediate: !constantsViewer.REACT_SPRING_ANIMATIONS_ACTIVE,
    config: constantsViewer.REACT_SPRING_ANIMATIONS_CONF,
  }));

  useEffect(() => {
    let self = group.current;
    if (self) {
      set({
        position: getPosition(cabinetHeight),
      });
    }
  }, [cabinetHeight]);

  return (top.crossPieces && top.crossPieces.length > 0) || top.plate ? (
    <a.group ref={group} position={spring.position}>
      {top.crossPieces.map(cp => {
        return (
          <CrossPiece
            crossPiece={cp}
            configuratorMode={configuratorMode}
            cabinetWidth={cabinetWidth}
            cabinetDepth={cabinetDepth}
            unselected={unselected}
            key={cp.position}
          />
        );
      })}

      {top.plate && (
        <Pane
          pane={top.plate}
          cabinetId={cabinetId}
          configuratorMode={configuratorMode}
          pPosition="O"
          cabinetId={cabinetId}
          configuratorMode={configuratorMode}
          cabinetWidth={cabinetWidth}
          cabinetDepth={cabinetDepth}
          unselected={unselected}
        />
      )}

      {top.glassPlate && (
        <Pane
          pane={top.glassPlate}
          pPosition="OG"
          cabinetWidth={cabinetWidth}
          cabinetDepth={cabinetDepth}
          unselected={unselected}
        />
      )}
    </a.group>
  ) : (
    <></>
  );
}

function getPosition(cabinetHeight) {
  return [0, (cabinetHeight - 450) / 2, 0];
}
